import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
    Button,
    Col,
    Form,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"


import { useSelector, useDispatch } from "react-redux"
import { addNewInvoiceHistory, setInvoiceHistoryLoading } from "store/actions"
import SweetAlert from "react-bootstrap-sweetalert"

const PayInvoiceModal = props => {
    const { isOpen, toggle, processData } = props
    const { timestamp = null } = processData || {}



    const dispatch = useDispatch()


    const { loading } = useSelector(state => ({
        loading: state.invoiceHistoryes.loading
    }))

    const [title, settitle] = useState("")
    const [saving, setSaving] = useState(false)
    const [alert, setAlert] = useState(null)
    const date = Date.now(new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })).toString();

    document.title = "Orders | Payment Form"

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            PaymentDate: "2025/10/10",
            PayNumber: "6545",
            Price: 65,
            Currency: "USD",
            PayMethod: "PayPal",
            timestamp: "",
        },
        validationSchema: Yup.object({
            PaymentDate: Yup.date().required("Payment date is required"),
            PayNumber: Yup.string().required("Pay number is required"),
            Price: Yup.number().positive().required("Price is required"),
            Currency: Yup.string().oneOf(["USD", "EUR", "PKR", "GBP"]).required(),
            PayMethod: Yup.string().oneOf(["PayPal", "CreditCard", "BankTransfer"]).required(),
            timestamp: Yup.string().required(),
        }),
        onSubmit: async values => {
            try {
                setSaving(true)
                values.mauth_id = processData?.mauth_id
                values.refId = processData?._id
                values.invId = processData?.timestamp,
                    values.company = processData?.company,
                    values.contactPerson = processData?.contactPerson,
                    values.inv = processData.inv
                dispatch(addNewInvoiceHistory(values))
                dispatch(setInvoiceHistoryLoading())
                setSaving(false)

                toggle()
            } catch (err) {
                console.error(err)
                setSaving(false)
            }
        },
    })

    useEffect(() => {
        if (isOpen && processData) {
            validation.setValues({ ...validation.initialValues, ...processData })
        }
        validation.setValues({ ...validation.initialValues, ...{ timestamp: date } })
        settitle(`invoice No: ${timestamp}`)
    }, [isOpen])

    useEffect(()=>{
        if(loading && isOpen){
            
             setAlert(<SweetAlert
                    // title="Success"
                    success
                    confirmBtnText = "OK"
                    title={`Your Invoice Successfully Generated `}
                    onConfirm={() =>{dispatch(setInvoiceHistoryLoading()), setAlert(false)}}
                    onCancel={()=>{ dispatch(setInvoiceHistoryLoading()),setAlert(false)}}
                    focusCancelBtn
                  >Payment Updated Succesfully</SweetAlert>)
        }
    },[loading])

    return (
        <>
        
            <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Payment Date</Label>
                                    <Input
                                        name="PaymentDate"
                                        type="date"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.PaymentDate || ""}
                                        invalid={validation.touched.PaymentDate && !!validation.errors.PaymentDate}
                                    />
                                    <FormFeedback>{validation.errors.PaymentDate}</FormFeedback>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Pay Number</Label>
                                    <Input
                                        name="PayNumber"
                                        type="text"
                                        placeholder="Enter payment number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.PayNumber || ""}
                                        invalid={validation.touched.PayNumber && !!validation.errors.PayNumber}
                                    />
                                    <FormFeedback>{validation.errors.PayNumber}</FormFeedback>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Price</Label>
                                    <Input
                                        name="Price"
                                        type="number"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Price}
                                        invalid={validation.touched.Price && !!validation.errors.Price}
                                    />
                                    <FormFeedback>{validation.errors.Price}</FormFeedback>
                                </div>
                            </Col>

                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Currency</Label>
                                    <Input
                                        type="select"
                                        name="Currency"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Currency}
                                    >
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="PKR">PKR</option>
                                        <option value="GBP">GBP</option>
                                    </Input>
                                </div>
                            </Col>

                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Payment Method</Label>
                                    <Input
                                        type="select"
                                        name="PayMethod"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.PayMethod}
                                    >
                                        <option value="PayPal">PayPal</option>
                                        <option value="CreditCard">Credit Card</option>
                                        <option value="BankTransfer">Bank Transfer</option>
                                    </Input>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className="mb-3">
                                    <Label>Timestamp</Label>
                                    <Input
                                        name="timestamp"
                                        type="text"
                                        disabled
                                        value={validation.values.timestamp}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col className="text-end">
                                <Button color="primary" type="submit" disabled={saving}>
                                    {saving ? "Saving..." : "Save"}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            {alert}
        </>
    )
}

PayInvoiceModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
    processData: PropTypes.object,
}

export default PayInvoiceModal
